import localForage from 'localforage'
import { customFetchForXML } from 'services/jwt'

export const fetch = async (url: string, options: RequestInit) => {
  const accessToken = await localForage.getItem('app.user.token')
  // tokenType은 Bearer로 고정.
  const tokenType = 'Bearer'
  // const tokenType = await localForage.getItem('app.user.tokenType')

  const opts = {
    ...options,
  }

  if (opts.headers == null) {
    opts.headers = {}
  }

  // TypeScript 타입 안전성을 위해 Record<string, string>으로 캐스팅
  const headers = opts.headers as Record<string, string>
  headers.Authorization = `${tokenType} ${accessToken}`

  // headers['Access-Control-Allow-Headers'] = 'Content-Type';

  let res = null
  if (url.indexOf('.well-known') > -1) {
    // res = await window.fetch(url, opts);
    return Promise.resolve(null)
  } else {
    res = await customFetchForXML(url, opts, {
      getHeaders: async (token) => {
        const newTokenType = await localForage.getItem('app.user.jmap.tokenType')
        return {
          Authorization: `${newTokenType} ${token}`,
        }
      },
    })
  }

  return res
}
